module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/4-d96461b2409b53bf5c323551b0d93ac3.jpg";